import directusHelper from "../helpers/directus";

export default {
    methods: {
        getUrl(name, resize = false) {
            return directusHelper.getAssetUrl(name, resize);
        },
        getSection(name) {
            if (!this.$store.state.sections) return {};
            return this.$store.state.sections.find(
                section => section.name === name
            );
        },
        getGallery(name) {
            const data = this.$store.state.galleries.find(
                gallery => gallery.name === name
            );
            return data || {};
        }
    }
};
